import { render } from "./addressesList.vue?vue&type=template&id=f63a8794"
import script from "./addressesList.vue?vue&type=script&lang=js"
export * from "./addressesList.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__